import { render, staticRenderFns } from "./gptCreate.vue?vue&type=template&id=4a8ff944&"
import script from "./gptCreate.vue?vue&type=script&lang=js&"
export * from "./gptCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports